<template>
  <li @mouseover="focus" @mouseleave="blur" :class="item.variant" role="menuitem">
    <DropDownItemPopover :popover="item.popover" :testId="`${testId}-drop-down-item-popover`">
      <DropDownItemMap :item="item" @clicked="$emit('clicked')" :testId="testId">
        <div
          class="nx-text-body3 tw-flex tw-flex-row tw-items-center tw-py-2 tw-px-4 tw-w-full"
          :class="colorClass"
        >
          <div class="tw-flex tw-items-center">
            <font-awesome-icon
              v-if="item.icon"
              :icon="icon?.icon"
              :spin="icon?.spin"
              class="tw-text-base tw-mr-2"
            />
            <span class="dropdown-text">{{ item.name }}</span>
          </div>
          <div v-if="item.slot" class="tw-ml-1">
            <component :is="item.slot" />
          </div>
        </div>
      </DropDownItemMap>
    </DropDownItemPopover>
  </li>
</template>

<script>
import { computed, ref } from "vue";
import BtnLink from "@/components/display/BtnLink";
import DropDownItemMap from "@/components/display/DropDownItemMap.vue";
import DropDownItemPopover from "@/components/display/DropDownItemPopover.vue";

export default {
  name: "DropDownItem",
  components: {
    BtnLink,
    DropDownItemMap,
    DropDownItemPopover,
  },
  props: {
    testId: String,
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ["clicked"],
  setup: (props) => {
    const COLOR_MAP = {
      success:
        "tw-text-success-text-medium hover:tw-bg-success-background hover:tw-text-success-text",
      danger: "tw-text-danger-text-medium hover:tw-bg-danger-background hover:tw-text-danger-text",
      warning:
        "tw-text-warning-text-medium hover:tw-bg-warning-background hover:tw-text-warning-text",
      info: "tw-text-text hover:tw-bg-highlight-background-weak",
    };

    const active = ref(false);

    const blur = () => (active.value = false);

    const colorClass = computed(() => COLOR_MAP[props.item.variant] || COLOR_MAP.info);

    const focus = () => (active.value = true);

    const icon = computed(() =>
      !props.item.disabled && active.value
        ? props.item.icon?.hover || props.item.icon?.default
        : props.item.icon?.default
    );

    return {
      blur,
      colorClass,
      focus,
      icon,
    };
  },
};
</script>
